export default function IconChevronRight(props) {
  return (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" {...props}>
      <polyline points="9 18 15 12 9 6"/>
    </svg>
  )
}
